module.exports = __webpack_public_path__ + "static/media/PP5-GalaxyS8.bdf01fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper5/PP5-GalaxyS8.png
// module id = 282
// module chunks = 0